// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem } from "reactstrap";
import TableWithSortPagtn from "../../common/TableForLeaveSummaryReport";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
import api from "../../../apis/api";
import Notifications from "../../common/Notifications";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";

const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let sumhours=0;
let sumbillable=0;
let estimated=0;
let maxwidth="80vw";
const ListLeaveSummaryReport = React.memo(
  ({
    handleAddEditTaskForm,
    handleSelectedTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm,
    handlereload,
    disablePagination
  }) => {
    const [thead] = useState([
      // "#",
      "Employee ID",
      "Employee Name",
      "Department",
      "Leave Details",
      "Total Leaves",
       
    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
   const [curstatus,setcurstatus] =useState(0);
   const [curstatusList,setcurstatusList] = useState([]);
   const [reason,setreason] = useState("");
   const [error, setError] = useState(null);
   const [loaded, setLoaded] = useState(false);
   
   const DarkBackground = styled.div`
   display: none; /* Hidden by default */
     position: fixed; /* Stay in place */
     z-index: 999; /* Sit on top */
     left: 0;
     top: 0;
     width: 100%; /* Full width */
     height: 100%; /* Full height */
     overflow: auto; /* Enable scroll if needed */
     background-color: rgb(0, 0, 0); /* Fallback color */
     background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
   ${(props) =>
     props.disappear &&
     css`
       display: block; /* show */
     `}
   `;
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );

   

    const DelTask=React.useCallback(
      (delId)=>{
      handleDelTask(delId);
    },[empTask]);


    const chunkSize = 30;
    const breakStringIntoChunks = (str, chunkSize) => {
      const chunks = [];
      for (let i = 0; i < str.length; i += chunkSize) {
        chunks.push(str.substring(i, i + chunkSize));
      }
      return chunks;
    };
    useEffect(() => {
      sumhours=0;
      sumbillable=0;
      estimated=0;
      empTask.map((el) =>{
        sumhours = sumhours+el.hoursSpent;
        sumbillable =sumbillable+el.hoursBillable;
        estimated=estimated+el.estimatedHour;
      }); 
      let trow = empTask.map((el,i) => ({
        // "#":<div style={{width:'100px'}}>{i+1}</div>,
       "Employee ID": <div style={{width:'100px'}}>{el.employeeCode}</div>,
        "Employee Name": (
         <div style={{width:'140px'}}><h2 className="table-avatar">

            <span className="ml-2">
              <span style={{ fontWeight: "400", color: "black" }}>
                {el.employeeName}
              </span>
              {/* <span> {el.empDesignation}</span> */}
            </span>
          </h2></div>
        ),
        Department: <div style={{width:'100px'}}>{el.departmentName}</div>,
        "Leave Details":<div style={{width:'100px'}}>{el.isAuto == true && el.leaveDetails === "Loss Of Pay(LOP)" ? "Auto LOP" : el.leaveDetails}</div>,
        "Total Leaves":<div style={{width:'50px'}}>{el.totalLeave}</div>,
        
      }));
   
      // trow.sort((a, b) => a["#"] - b["#"]);
      setTrow(trow);
    }, []);
    const onchangeApprovestatus=React.useCallback((val) =>{
      // let formData = {};
      // const ids = empTask.map(user => user.timesheetStatusId);
      // const joinedString=ids.join(',');
      // formData = {
      
      //   employeeTimeSheetIdList:joinedString,
      //   approvedStatus:true,
      //   approvedId:parseInt(loginUser.EmployeeId),        
      //   reason:""
      // };
      // await api.task().ApproveTaskStatus(formData);
      setcurstatus(val);
      setcurstatusList({value : val ,label : val==1 ? "Approve" :"Rejected"})
    },[setcurstatus,setcurstatusList]);
    const handleChange =(reason) =>{
      setreason(reason.target.value);
    }
    const handleSubmit=React.useCallback( async () => {
      setLoaded(true);
      let formData = {};
      const ids = empTask.map(user => user.timesheetStatusId);
      const joinedString=ids.join(',');
      formData = {
      
        employeeTimeSheetIdList:joinedString,
        approvedStatus:curstatus==1 ? true :false,
        approvedId:parseInt(loginUser.EmployeeId),        
        reason:reason
      };

      if(curstatus == 1)
        {
          setcurstatusList([]);
          setreason("");
          setcurstatus(0);
          await api.task().ApproveTaskStatus(formData);
          setError({ ...error, message: "Work Status Approved Successfully..", status: 200 });
          // setError({ ...error, message: "Work Status Approved Successfully..", status: 200 });
        }
        else if(curstatus == 2)
        {
          if(reason != '')
          {
            setcurstatusList([]);
            setreason("");
            setcurstatus(0);
          await api.task().ApproveTaskStatus(formData);
          setError({ ...error, message: "Work Status Rejected Successfully..", status: 200 });
          }
          // setError({ ...error, message: "Work Status Rejected Successfully..", status: 200 });
        }
        else
        {
          setError({ ...error, message: "Choose approve/reject..", status: 500 });
        }
        handlereload(curstatus,reason);
    //  setTimeout(() => { 
   
          
    //   }, 3000);
     
    },[setcurstatusList,setreason,setcurstatus,empTask,loginUser,curstatus,reason])
    return (
      <Fragment>
       
        <div className="" style={{ maxWidth: maxwidth, overflowY: disablePagination ? "visible !important" : "auto", maxHeight: disablePagination ? "auto !important" : "80vh" }}>
      <TableWithSortPagtn thead={thead} trow={trow} pageSize={5} sumhours={Math.round(sumhours * 100) / 100} sumbillable={sumbillable} estimated={Math.round(estimated * 100) / 100} onchangeApprovestatus={onchangeApprovestatus} curstatus={curstatus} handleSubmit={handleSubmit} handleChange={handleChange} curstatusList ={curstatusList} disablePagination={disablePagination}></TableWithSortPagtn>
    </div>
    <Notifications notifications={error}></Notifications>
    <DarkBackground disappear={loaded}>
    <LoadingOverlay
          active={true}
          spinner={true}
          text="Loading your content..."
        >
        </LoadingOverlay>
    </DarkBackground>
        {/* <div className="mt-3">
          <ListGroup className="task-list ">
            {empTask.map((tasks, i) => (
              <ListGroupItem
                key={i}
                onClick={() => handleOnclickSelectedTask(tasks, i)}
                style={i === activeTask ? active : null}
              >
                <div className="task-container ">
                  <span className="task-check">
                  {tasks.timeSheetStatus ==3 ? (<i className="fas fa-check  project-task-icon" style={{ color: 'green'}}></i>) : <i className="fas fa-check  project-task-icon"></i>}
                    
                  </span>
                  <span className="task-label">{tasks.description}</span>
                  <span className="task-label">{tasks.hoursSpent}</span>
                  <span className="task-label">{tasks.timeSheetStatus}</span>
                  <span className="task-action-btn task-btn-right">
                    <span
                      className="action-circle large task-assign"
                      title="Assign"
                    >
                      <i className="fas fa-user  project-task-icon"></i>
                    </span>
                    <span
                      className="action-circle large delete-btn"
                      title="Delete Task"
                      onClick={() => DelTask(tasks.employeeTimeSheetId)}
                    >
                      <i className="fas fa-trash project-task-icon"></i>
                    </span>
                  </span>
                </div>
              </ListGroupItem>
            ))}
          </ListGroup>
        </div> */}
      </Fragment>
    );
  }
);

export default ListLeaveSummaryReport;
